import { render, staticRenderFns } from "./historicalProcess.vue?vue&type=template&id=2ced8c40&scoped=true&"
import script from "./historicalProcess.vue?vue&type=script&lang=js&"
export * from "./historicalProcess.vue?vue&type=script&lang=js&"
import style0 from "./historicalProcess.vue?vue&type=style&index=0&id=2ced8c40&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ced8c40",
  null
  
)

export default component.exports